<template>
  <MTableCell
    v-show="showColumn"
  >
    <MLink
      v-if="canReadLink"
      v-overflow-title="textValue"
      class="m-table-cell__ellipsis-wrapper"
      :to="getUrl"
    >
      {{ textValue }}
    </MLink>
    <template v-else>
      <div class="m-table-cell__ellipsis-wrapper">
        {{ textValue }}
      </div>
    </template>
  </MTableCell>
</template>

<script>
  import {MLink, mTableCells} from '@marilyn/marilyn-ui';
  import {mapGetters} from 'vuex';
  import _ from 'lodash';
  _.noConflict();

  export default {
    name: 'MTableCellRouterLink',
    components: {
      MLink,
      MTableCell: mTableCells.MTableCell
    },
    props: {
      index: {
        type: [Number, String],
        default: ''
      },
      itemKey: {
        type: String,
        default: ''
      },
      tableRow: {
        type: Object,
        default: Object
      },
      showColumn: {
        type: Boolean,
        default: true
      },
      route: {
        type: Function,
        default: () => Object
      },
      linkPermission: {
        type: [String, Array],
        default: Array
      }
    },
    computed: {
      ...mapGetters('user', ['canUser']),
      getUrl () {
        return this.route(this.tableRow);
      },
      canReadLink () {
        return this.canUser(this.linkPermission);
      },
      textValue () {
        return this.tableRow[this.itemKey];
      }
    }
  };
</script>
